var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { color, space, typography } from 'styled-system';
import { mq, styled } from "../utils";
var renderStyledHeading = function (key) {
    return styled(key)(function (_a) {
        var headings = _a.theme.components.headings;
        return mq(headings[key]);
    }, typography, color, space);
};
var Heading = function (key) { return function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var StyledHeading = renderStyledHeading(key);
    return (React.createElement(StyledHeading, __assign({ "data-component": "Heading-" + key }, props), children));
}; };
export default {
    Heading1: Heading('h1'),
    Heading2: Heading('h2'),
    Heading3: Heading('h3'),
    Heading4: Heading('h4'),
    Heading5: Heading('h5'),
    Heading6: Heading('h6'),
};
//# sourceMappingURL=Heading.js.map